import { AxiosInstance } from 'axios';
import { ListModel, ListQueryParam } from '../models';
import { IResponseMessages } from '../models/response-messages.model';

export abstract class NewReadOnlyClient<ResponseModel, QueryModel extends ListQueryParam = ListQueryParam> {
    protected constructor(
        protected api: AxiosInstance,
        protected basePath: string,
    ) {}

    public async getList(
        { pageSize = 10, ...query }: QueryModel,
        messages?: IResponseMessages,
    ): Promise<ListModel<ResponseModel>> {
        const { data } = await this.api.get<ListModel<ResponseModel>>(this.basePath, {
            params: { pageSize, ...query },
            successMessage: messages?.onGetSuccessMessage,
            errorMessage: messages?.onGetErrorMessage,
        });
        return data;
    }

    public async getOne(id?: string, messages?: IResponseMessages): Promise<ResponseModel> {
        const { data } = await this.api.get<ResponseModel>(`${this.basePath}/${id}`, {
            successMessage: messages?.onGetSuccessMessage,
            errorMessage: messages?.onGetErrorMessage,
        });
        return data;
    }
}
